// extracted by mini-css-extract-plugin
export default {"navCTA":"_3sIED","ctaButton":"_2UDQf"};